import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M60.3899 15.5488C57.4887 11.2309 53.5459 7.68798 48.9141 5.2369C44.2823 2.78582 39.1057 1.50293 33.8472 1.50293C28.5887 1.50293 23.4122 2.78582 18.7804 5.2369C14.1486 7.68798 10.2058 11.2309 7.3045 15.5488C-1.79413 28.7273 1.9768 58.5481 7.73926 68.203C14.0578 78.7737 26.1993 87.5029 33.8421 87.5029C41.485 87.5029 53.6266 78.7737 59.9451 68.203C65.7076 58.5083 69.4683 28.6875 60.3899 15.5488Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
